// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"23":"453529b9","192":"db875612","283":"a82a5a93","455":"a82a5a93","584":"e6a76c12","794":"eb98ec86","898":"e0ae165b","950":"614627dc"}[chunkId] + ".chunk.css";
};